// InventorySearchSubTabs.js
import React, { useState } from "react";
import OrdersTableIncoming from "./OrdersTableIncoming";

// Define the available subtabs and their corresponding components
const subTabConfigs = {
  inventory: {
    label: "Orders",
    component: OrdersTableIncoming,
  },
  // Example for another subtab (you can add more if needed)
  // details: {
  //   label: "Details",
  //   component: ShipmentDetailsComponent,
  // },
};

const OrdersSearchSubTabs = ({
    searchQuery,
    statusFilter,
    searchTrigger,
    setTotalOrders,
}) => {
  // Set default selected subtab to "inventory"
  const [selectedSubTab, setSelectedSubTab] = useState("inventory");
  const currentSubTabConfig = subTabConfigs[selectedSubTab];

  return (
    <div className="w-full h-full flex flex-col">
      {/* Subtab navigation */}
      <div className="shrink-0 border-b border-gray-200">
        <div className="flex space-x-8">
          {Object.entries(subTabConfigs).map(([key, config]) => (
            <button
              key={key}
              onClick={() => setSelectedSubTab(key)}
              className={`px-1 py-4 text-sm font-medium ${
                selectedSubTab === key
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              {config.label}
            </button>
          ))}
        </div>
      </div>

      {/* Search info banner */}
      {searchQuery && (
        <div className="shrink-0 px-4 py-2 bg-blue-50 dark:bg-blue-900/20 border-b border-blue-100 dark:border-blue-800 text-sm text-blue-700 dark:text-blue-300">
          Showing search results for: <span className="font-semibold">"{searchQuery}"</span>
        </div>
      )}

      {/* Subtab content */}
      <div className="h-full min-h-0 overflow-hidden flex flex-col">
        {currentSubTabConfig.component && (
          <currentSubTabConfig.component
            searchQuery={searchQuery}
            statusFilter={statusFilter}
            searchTrigger={searchTrigger}
            setTotalOrders={setTotalOrders}
          />
        )}
      </div>
    </div>
  );
};

export default OrdersSearchSubTabs;
